import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Messages } from 'primereact/messages';
import { getFormErrorMessage } from '../../../utils/errors';
import { ProgressSpinner } from '../../../../components/PrimereactComponents';
import { ModalDialog } from '../../../components/ModalDialog';
import { ButtonDownload } from '../../../components/Buttons';
import { FormContainer, FormInput, FormRow, Label } from '../../../components/form';
import { RHFCheckbox } from '../../../components/rhf';


export const ExportDialog = forwardRef(({
    isVisible,
    onHide,
    onSubmitOne,
    onSubmitList,
    databaseOne,
    databaseList,
    msgs
}, ref) => {
    const [processing, setProcessing] = useState(false);

    useImperativeHandle(ref, () => ({
        reset: reset
    }));

    const formId = 'export-database-dialog';

    const bulkExport = !databaseOne;
    const onSubmit = bulkExport ? onSubmitList : onSubmitOne;

    const defaultValues = useMemo(
        () => ({
            create_db: true,
            drop_db: true,
            drop_table: true,
            include_data: true
        }), []
    );

    const {
        control,
        formState: { errors, isSubmitting },
        handleSubmit,
        reset
    } = useForm({
        disabled: processing,
        defaultValues: defaultValues
    });

    useEffect(() => {
        setProcessing(isSubmitting);
    }, [isSubmitting]);

    useEffect(() => {
        if (!isVisible) {
            msgs?.current?.clear();
        }
    }, [isVisible, msgs]);

    return(
        <ModalDialog
            visible={isVisible}
            onHide={onHide}
            header={bulkExport ? `Exportovat databáze` : `Exportovat databázi ${databaseOne.name}`}
            footer={
                <ButtonDownload
                    label="Exportovat"
                    type="submit"
                    form={formId}
                    disabled={processing}
                    loading={processing}
                />
            }
            style={{ width: 500 }}
        >
            <Messages ref={msgs} className='flex-center' />

            <form onSubmit={handleSubmit(onSubmit)} id={formId}>
                    <FormContainer type='dialog'>
                        <FormRow>
                            <FormInput type='checkbox'>
                                <div className='db-export-checkbox-container'>
                                    <RHFCheckbox control={control} name='create_db' />
                                    <Label
                                        htmlFor='create_db'
                                        text='Exportovat s příkazy CREATE DATABASE'
                                    />
                                </div>
                            </FormInput>
                        </FormRow>
                        <FormRow>
                            <FormInput type='checkbox'>
                                <div className='db-export-checkbox-container'>
                                    <RHFCheckbox control={control} name='drop_db' />
                                    <Label
                                        htmlFor='drop_db'
                                        text='Exportovat s příkazy DROP DATABASE'
                                    />
                                </div>
                            </FormInput>
                        </FormRow>
                        <FormRow>
                            <FormInput type='checkbox'>
                                <div className='db-export-checkbox-container'>
                                    <RHFCheckbox control={control} name='drop_table' />
                                    <Label
                                        htmlFor='drop_table'
                                        text='Exportovat s příkazy DROP TABLE'
                                    />
                                </div>
                            </FormInput>
                        </FormRow>
                        <FormRow>
                            <FormInput type='checkbox'>
                                <div className='db-export-checkbox-container'>
                                    <RHFCheckbox control={control} name='include_data' />
                                    <Label
                                        htmlFor='include_data'
                                        text='Exportovat s daty'
                                    />
                                </div>
                            </FormInput>
                        </FormRow>
                    </FormContainer>
            </form>

        </ModalDialog>
    );

});
